import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import UserRestServices from '../../services/user-rest.service';
import Config from '../../utils/config.service';
import Toast from '../../services/toast.service';
import DialogServices from '../../services/dialog.service';
import BusinessRestServices from '../../services/business-rest.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import $ from 'jquery';
import moment from 'moment';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalCsvDependentsInstructionsComponent } from '../modal-csv-dependents-instructions/modal-csv-dependents-instructions.component';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'item-invitation-dependent',
	templateUrl: './item-invitation-dependent.component.html',
	imports: [
		CommonModule, MatSelectModule, LowerCasePipe, TranslatePipe, 
		LoaderOverlayComponent, InputAutocompleteComponent, 
		InputDatepickerNewComponent, ItemErrorComponent, FormsModule
	]
})
export class ItemInvitationDependentComponent implements OnInit {
	private userRestServices: UserRestServices = inject(UserRestServices);
	private config: Config = inject(Config);
	private toast: Toast = inject(Toast);
	private dialogServices: DialogServices = inject(DialogServices);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() form: any | undefined;
	@Output() formChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() dependent: any | undefined;
	@Output() dependentChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.uid = Date.now();
		
		this.vm.user = this.session.getSession().user;
		this.vm.canUserManuallyAddInsurance = this.session.canUserManuallyAddInsurance();
		this.vm.isInsuranceDatePickerHidden = this.session.isInsuranceDatePickerHidden();
		this.initNewDependent();
		
		if (this.vm.user.service.insuranceChangesInFuture) {
			var today: any = new Date();
			var minDate: any = new Date();
			minDate.setDate(today.getDate() + this.config.getOtherConfig().INSURANCE_CHANGE_DELAY_IN_DAYS);
			this.vm.minDate = minDate;
		} else {
			this.vm.minDate = new Date(2020, 0, 1);
		}
		this.vm.handleSubmit = this.handleSubmit;
		this.vm.openInstructionsModal = this.openInstructionsModal;
		this.vm.uploadCSV = this.uploadCSV;
		this.vm.handleEmployeeSearch = this.handleEmployeeSearch;
		this.vm.handleEmployeeClear = this.handleEmployeeClear;
		this.vm.handleSelect = this.handleSelect;
		
		this.vm.isPersonalCodeRequiredForInvite = this.vm.user.origin == 'minudoc.ee'
			&& !this.vm.user.service.personalCodeNotRequiredForInvite;
	}
	
	handleSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing || !this.vm.employee) return;
		var names: any = this.getNames();
		
		var data: any = {
			worker: this.vm.employee.worker,
			employer: this.vm.employee.employer,
			firstName: names.first,
			lastName: names.last,
			email: this.vm.dependent.email,
			personalCode: this.vm.dependent.idcode,
			additionalInfo: this.vm.dependent.additionalInfo,
			additionalInfo2: this.vm.dependent.additionalInfo2
		};
		if (this.vm.invitationExtra && this.vm.selectedPolicy && this.vm.selectedPolicy.policyNumber) {
			data.invitationExtras = [];
			var extraData: any = {};
			extraData.policy = {};
			extraData.policy.policyNumber = this.vm.selectedPolicy.policyNumber;
			extraData.activationDate = this.vm.invitationExtra.activationDate
				? moment(this.vm.invitationExtra.activationDate).utcOffset(0, true).toDate()
				: new Date();
			extraData.terminationDate = this.vm.invitationExtra.terminationDate
				? moment(this.vm.invitationExtra.terminationDate).utcOffset(0, true).toDate()
				: undefined;
			data.invitationExtras.push(extraData);
		}
		
		this.businessRestServices.inviteDependent(data,
			() => {
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Dependents.ADDED);
				this.vm.submitted = false;
				this.vm.processing = false;
				this.vm.employee = undefined;
				this.initNewDependent();
				mainForm.reset();
			},
			(err) => {
				var errorMessage: any = (err.error && err.error[0] && err.error[0].message ? err.error[0].message : "");
				if (errorMessage == "MaxAllowedDependentsReached") {
					var toastMessage = this.angularFilterHelperService.translate('Dependents.Errors.MaxAllowedDependentsReached');
					this.toast.showAsync(toastMessage, null, null, 'error');
				}
				this.vm.processing = false;
			}
		);
	}
	
	initNewDependent() {
		this.vm.dependent = {};
		this.vm.employee = undefined;
		this.vm.employeePolicies = undefined;
		this.vm.selectedPolicy = undefined;
		if (this.vm.canUserManuallyAddInsurance) {
			this.vm.invitationExtra = {};
			this.vm.invitationExtra.policy = {};
		}
	}
	
	getNames() {
		var arr: any = this.vm.dependent.name.split(' ');
		arr = arr.filter((el) => { return el.trim(); });
		var names: any = {};
		names.last = arr.pop();
		names.first = arr.join(' ');
		
		return names;
	}
	
	openInstructionsModal() {
		this.dialogServices.show({
			controller: ModalCsvDependentsInstructionsComponent
		});
	}
	
	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		this.uploadCSV(input.files);
	}
	
	uploadCSV(files) {
		if (!files || !files.length || this.vm.processing) return;
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		var file: any = files[0];
		var data: any = new FormData();
		data.append('file', file);
		this.userRestServices.uploadDependentsCSV({ name: file.name }, data,
			() => {
				this.handleUploadOnComplete(true);
				this.toast.showAsync(this.angularFilterHelperService.translate('Dependents.Import_Successful'));
			},
			() => {
				this.handleUploadOnComplete();
				this.toast.showAsync(this.angularFilterHelperService.translate('Dependents.Errors.Import'), null, null, 'error');
			}
		);
	}
	
	handleUploadOnComplete(isSuccessful?) {
		$('#file-' + this.vm.uid).val('');
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) {
			this.angularHelperService.createTimer(() => {
				this.vm.processing = false;
				if (isSuccessful) this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Dependents.ADDED);
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		}
	}
	
	handleSelect = (selectedEmployee) => {
		this.vm.employee = selectedEmployee;
		if (selectedEmployee && selectedEmployee.insuranceWallets) {
			var availablePolicies: Array<any> = [];
			selectedEmployee.insuranceWallets.forEach((wallet) => {
				availablePolicies.push(wallet.policy);
			});
			this.vm.employeePolicies = availablePolicies;
		}
	}
	
	handleEmployeeClear = () => {
		this.vm.employee = undefined;
		this.vm.employeePolicies = undefined;
	}
	
	handleEmployeeSearch = (searchInput) => {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.businessRestServices.getWorkers(
			{
				name: searchInput.namePart,
				pageSize: 10,
				activeOnly: true, 
				includeInsurance: (this.hasInsurance() ? true : false) 
			}, 
			(employees) => {
				employees.forEach((employee) => {
					employee.name = employee.firstName + ' ' + employee.lastName + ', ' + employee.email;
				});
				deferred.resolve(employees);
			}
		);
		
		return deferred.promise;
	}
	
	hasInsurance() {
		return this.vm.user && this.vm.user.activeInsurancePolicies && this.vm.user.activeInsurancePolicies.length > 0;
	}
	
}